import { observer } from "mobx-react";
import React from "react";
import { FieldRenderProps } from "react-final-form";

import withFieldControl from "components/FormControl/FieldControl";
import { computed, observable } from "mobx";
import AnswerOptionStore from "stores/AnswerOptionStore";
import { Button, FormLabel } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { DictionaryItem, PUBLISH_STATUSES } from "constants/models";
import { ValueType } from "react-select";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import {
  Container,
  ControlContainer,
  ControlHeader,
  OptionCards,
  Row,
} from "./styles";
import { reorder } from "utils/calculation";
import OptionCard from "./OptionCard";
import OptionForm from "./OptionForm/OptionForm";
import Popup from "components/Popup";
import Placeholder from "components/Placeholder";
import QuestionStore from "stores/QuestionStore";
import { SNACKBAR_TYPES } from "components/Snackbar";
import { withGlobalSnackbar } from "services/snackbar/snackbarContext";

type Props = {
  questionID?: number;
};

@observer
class OptionControl extends React.Component<FieldRenderProps<any> & Props> {
  @observable isPopupOpen: boolean = false;
  @observable dataEdit: any = null;

  @computed
  get values() {
    const { input } = this.props;
    const value = input?.value || [];

    return value.map((item: any) => ({ label: item.title, value: item }));
  }

  @computed get filteredOptions() {
    return AnswerOptionStore.answerOptions.filter(
      option => !this.values.find(({ value }) => value.id === option.value.id),
    );
  }

  onChange = (items: DictionaryItem[] = []) => {
    const {
      input: { onChange },
    } = this.props;

    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    onChange(event);
  };

  onRemoveItem = (option: ValueType<DictionaryItem>) => async () => {
    const { id } = option.value;
    console.log(id, PUBLISH_STATUSES.DRAFT);
    await AnswerOptionStore.changeAnswerOptionStatus(
      Number(id),
      PUBLISH_STATUSES.DRAFT,
    );
    QuestionStore.fetchQuestionDetails(this.props.questionID);
  };

  closePopup = () => {
    this.isPopupOpen = false;
  };

  openPopup = (option: any) => () => {
    this.dataEdit = option;
    this.isPopupOpen = true;
  };

  onDragEnd = async (result: DropResult) => {
    // dropped outside the list
    if (
      !result.destination ||
      !result.source ||
      result.source.index === result.destination.index
    ) {
      return;
    }

    const startIndex = result.source.index;
    const endIndex = result.destination.index;

    const reorderedOptions = reorder(this.values, startIndex, endIndex);
    this.onChange(reorderedOptions);

    const newOrder: any[] = [];
    reorderedOptions.map(item => newOrder.push({ id: item.value.id }));
    await AnswerOptionStore.updateAnswerOptionOrder(newOrder);
  };

  onManageOptionSubmit = async (values: any) => {
    const { setMessage } = this.props;
    const { file, id, title, code, questionID, displayOrder, tag } = values;
    const data = {
      id,
      title: title.trim(),
      code: code.trim(),
      questionID: questionID === undefined ? this.props.questionID : questionID,
      displayOrder: displayOrder === undefined ? 1 : displayOrder,
      tagsIds: tag?.map(({ id }: { id: number }) => id),
    };

    const payload = { id, data };
    console.log(payload);
    try {
      const newOption = data.id === undefined;
      if (newOption) {
        const id = await AnswerOptionStore.createAnswerOption(payload.data);
        if (id) {
          if (file) {
            const payloadFile = { file, id };
            await AnswerOptionStore.editAnswerOptionIcon(payloadFile);
          }
        }
        QuestionStore.fetchQuestionDetails(this.props.questionID);
      } else {
        const { id } = await AnswerOptionStore.editAnswerOptionInfo(payload);
        if (id) {
          if (file) {
            if (typeof file !== "string") {
              const payloadFile = { file, id };
              await AnswerOptionStore.editAnswerOptionIcon(payloadFile);
            }
          }
        }

        QuestionStore.fetchQuestionDetails(this.props.questionID);
      }
    } catch (error) {
      setMessage(error?.message, SNACKBAR_TYPES.ERROR);
    }
  };

  render() {
    return (
      <>
        {this.isPopupOpen && (
          <Popup
            onClose={this.closePopup}
            canCloseByOuterClick={false}
            withoutExitButton
          >
            <OptionForm
              isLoading={AnswerOptionStore.isOptionManaging}
              isFormLoading={AnswerOptionStore.isOptionLoading}
              initialValues={this.dataEdit}
              onSubmit={this.onManageOptionSubmit}
              onClose={this.closePopup}
              onChangeIsDirty={() => {}}
            />
          </Popup>
        )}
        <Container>
          <Row>
            <ControlHeader>
              <FormLabel>Options</FormLabel>
              <ControlContainer>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<AddIcon />}
                  onClick={this.openPopup(null)}
                >
                  Add Options
                </Button>
              </ControlContainer>
            </ControlHeader>
          </Row>

          {this.values.length ? (
            <Row>
              <OptionCards>
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {this.values.map((item, index) => (
                          <Draggable
                            key={item.value.id}
                            draggableId={item.value.id.toString()}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <OptionCard
                                details={item}
                                isPopupOpen={this.openPopup(item)}
                                key={item.value.id}
                                title={item.label}
                                onRemove={this.onRemoveItem(item)}
                                dragHandleProps={provided.dragHandleProps}
                                innerRef={provided.innerRef}
                                isDragging={snapshot.isDragging}
                                {...provided.draggableProps}
                                isEditMode
                              />
                            )}
                          </Draggable>
                        ))}

                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </OptionCards>
            </Row>
          ) : (
            <Placeholder
              height={132}
              width={132}
              text={"No options added yet."}
            />
          )}
        </Container>
      </>
    );
  }
}

export default withGlobalSnackbar(withFieldControl(OptionControl));
